<section class="login-page">
  <div class="login-card">
    <h1>Sign in</h1>
    <p class="intro">Access your ReconcileX workspace to continue with statements and reconciliation.</p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <label>Email address</label>
      <input formControlName="email" type="email" placeholder="me@company.com" />
      @if (email.invalid && (email.dirty || email.touched)) {
        <div class="error">
          @if (email.errors?.['required']) { <small>Email is required.</small> }
          @if (email.errors?.['email']) { <small>Enter a valid email address.</small> }
        </div>
      }

      <label>Password</label>
      <input formControlName="password" type="password" placeholder="Enter your password" />
      @if (password.invalid && (password.dirty || password.touched)) {
        <div class="error">
          @if (password.errors?.['required']) { <small>Password is required.</small> }
        </div>
      }

      <div class="actions">
        <button class="btn primary" type="submit" [disabled]="form.invalid || isSubmitting">
          {{ isSubmitting ? 'Signing in...' : 'Login' }}
        </button>
        <a class="btn ghost" routerLink="/register">Create account</a>
      </div>
    </form>

    @if (errorMessage) {
      <div class="message error-banner">{{ errorMessage }}</div>
    }
  </div>
</section>
